import { render, staticRenderFns } from "./member-configure-header.vue?vue&type=template&id=ade39ac6&scoped=true&"
import script from "./member-configure-header.vue?vue&type=script&lang=ts&"
export * from "./member-configure-header.vue?vue&type=script&lang=ts&"
import style0 from "./member-configure-header.vue?vue&type=style&index=0&id=ade39ac6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade39ac6",
  null
  
)

export default component.exports